import React, { createContext, useContext, useState } from 'react';
interface User {
  email: string;
  name: string;
  picture: string;
  sub: string;
  verified: boolean;
}
interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  isLoggedIn: boolean;
  isVerified: boolean;
  logout: () => void;
}
const STORAGE_KEY = 'alinova_user';
const AuthContext = createContext<AuthContextType | undefined>(undefined);
export const AuthProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [user, setUserState] = useState<User | null>(() => {
    if (typeof window === 'undefined') return null;
    const savedUser = window.localStorage.getItem(STORAGE_KEY);
    return savedUser ? JSON.parse(savedUser) as User : null;
  });
  const setUser = (newUser: User | null) => {
    setUserState(newUser);
    if (newUser) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(newUser));
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  };
  const logout = () => setUser(null);
  const value: AuthContextType = {
    user,
    setUser,
    isLoggedIn: Boolean(user),
    isVerified: Boolean(user?.verified),
    logout
  };
  return <AuthContext.Provider value={value} data-id="element-898" data-mp="2va45vj2duc03">{children}</AuthContext.Provider>;
};
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth debe ser usado dentro de AuthProvider');
  }
  return context;
};